import { render, staticRenderFns } from "./createOrder2.vue?vue&type=template&id=246b1b9e&"
import script from "./createOrder2.vue?vue&type=script&lang=js&"
export * from "./createOrder2.vue?vue&type=script&lang=js&"
import style0 from "./createOrder2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports